/** Logos de marque dans leurs couleurs (lucide n'en a plus) : réservés aux liens vers le service qu'ils désignent. */

export function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg aria-hidden="true" className={className} viewBox="0 0 24 24">
      <path fill="#4285F4" d="M21.6 12.23c0-.71-.06-1.4-.19-2.06H12v3.9h5.38a4.6 4.6 0 0 1-2 3.02v2.54h3.24c1.9-1.75 2.98-4.32 2.98-7.4Z" />
      <path fill="#34A853" d="M12 22c2.7 0 4.97-.9 6.62-2.42l-3.24-2.5c-.9.6-2.05.96-3.38.96-2.6 0-4.82-1.76-5.61-4.13H3.05v2.58A10 10 0 0 0 12 22Z" />
      <path fill="#FBBC05" d="M6.39 13.91A6 6 0 0 1 6.08 12c0-.66.11-1.3.31-1.91V7.51H3.05A10 10 0 0 0 2 12c0 1.61.39 3.14 1.05 4.49l3.34-2.58Z" />
      <path fill="#EA4335" d="M12 5.96c1.47 0 2.79.5 3.82 1.5l2.87-2.87A9.63 9.63 0 0 0 12 2a10 10 0 0 0-8.95 5.51l3.34 2.58C7.18 7.72 9.4 5.96 12 5.96Z" />
    </svg>
  );
}

/** Le « in » est évidé : il prend le fond du bouton. */
export function LinkedInIcon({ className }: { className?: string }) {
  return (
    <svg aria-hidden="true" className={className} fill="#0077b5" viewBox="0 0 24 24">
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0Z" />
    </svg>
  );
}

export function GmailIcon({ className }: { className?: string }) {
  return (
    <svg aria-hidden="true" className={className} viewBox="0 0 24 24">
      <path fill="#4285F4" d="M1.64 20.5h3.82v-9.27L0 7.14v11.72c0 .9.73 1.64 1.64 1.64Z" />
      <path fill="#34A853" d="M18.55 20.5h3.81c.9 0 1.64-.73 1.64-1.64V7.14l-5.45 4.09Z" />
      <path fill="#FBBC04" d="M18.55 4.14v7.09L24 7.14V5c0-2.02-2.3-3.17-3.93-1.96Z" />
      <path fill="#EA4335" d="M5.46 11.23V4.14L12 9.05l6.55-4.91v7.09L12 16.14Z" />
      <path fill="#C5221F" d="M0 5v2.14l5.46 4.09V4.14L3.93 3.04C2.3 1.83 0 2.98 0 5Z" />
    </svg>
  );
}
